import path from 'utils/path';
import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/influencers',
  link: '/settings/influencers',
  go_promotions: ({ id, name }) => path(id, `/promotions/?nameInfluencer=${name}`),
};

export const getColumns = ({ editItem, deleteItem, goPromotions }) => [
  {
    id: 'iconId',
    type: 'avatar',
    label: 'Avatar',
    align: 'left',
    disableSort: 'true',
  },
  { id: 'name', label: 'Name', align: 'center' },
  { id: 'region', label: 'Region', align: 'center' },
  {
    id: 'more-menu',
    type: 'menu',
    items: [
      {
        id: 'delete',
        name: 'Delete',
        action: deleteItem,
        icon: 'eva:trash-2-outline',
        sx: { color: 'error.main' },
      },
      { id: 'edit', name: 'Edit', action: editItem, icon: 'eva:edit-fill' },
      { id: 'goPromotions', name: 'Promotions', action: goPromotions, icon: 'mdi:text-box-multiple-outline' },
    ],
    disableSort: true,
  },
];

export const getFilters = ({ region, options }) => [
  {
    id: 'regions',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
];
